import { render, staticRenderFns } from "./MsgElementAudio.vue?vue&type=template&id=d7280132"
import script from "./MsgElementAudio.vue?vue&type=script&lang=js"
export * from "./MsgElementAudio.vue?vue&type=script&lang=js"
import style0 from "./MsgElementAudio.vue?vue&type=style&index=0&id=d7280132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports